import { useRouteLoaderData } from '@remix-run/react'
import { z } from 'zod'

export const ClientEnvSchema = z.object({
  publicPath: z.string().default(''),
  buildTag: z.string(),
})

export type ClientEnv = z.infer<typeof ClientEnvSchema>

export const useClientEnv = (): ClientEnv => {
  const env = useRouteLoaderData('root')
  const clientEnv = ClientEnvSchema.safeParse(env)

  if (clientEnv.success) {
    return clientEnv.data
  }

  return {
    publicPath: '',
    buildTag: '',
  }
}
